import React from "react";
import "./comparepage.css";
import logo from "../../images/white-logo.png";
import Navbar from "../../components/navbar/Navbar";
import { BiSearch } from "react-icons/bi";
import image from "../../images/post1.png";
import image2 from "../../images/post2.png";
import Card from "../../components/card/Card";
import Cslider from "../../components/compare-slide/Cslider";
import { CompareApi } from "./CompareApi";
import parse from "html-react-parser";
import { CourseInfo } from "./CompareApi";
import Footer from "../../components/footer/Footer";
import FooterMob from "../../components/footer/FooterMob";
import { useState } from "react";
import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { baseUrl } from "../../context/BaseUrl";
import MobNav from "../../components/Mobnav/MobNav";

const ComparePage = () => {
  const { id } = useParams("");
  const [show, setShow] = useState(false);
  const [Institute, setInstitute] = useState("");
  const [Course, setCourse] = useState("");
  const [Compare0, setCompare0] = useState(false);
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [InstituteDet, setInstituteDet] = useState(false);

  useEffect(() => {
    axios
      .get(`${baseUrl}/user/institute/getallinstitute`)
      .then((response) => {
        setData(response.data);
      })
      .catch((err) => {
        console.log(err);
      });

    fetchData();
  }, []);

  const GetCourse = async (id) => {
    setInstitute(id);
    try {
      const response2 = await axios.get(
        `${baseUrl}/institute/course/getcourse/${id}`
      );
      setData2(response2.data);
      var insticourselen = response2.data.length;
      // console.log(response2.data)
    } catch (error) {
      console.error(error);
    }
  };

  const Compare = async () => {
    try {
      const compdata = await axios.get(
        `${baseUrl}/user/institute/getinstitute/${Institute}`
      );
      setCompare0(compdata.data);
      // console.log(compdata.data)

      setCourse("");
      setInstitute("");

      handleClose();
      console.log("0000", compdata);
    } catch (error) {
      console.error(error);
    }
  };

  async function fetchData() {
    try {
      const responseq = await axios.get(
        `${baseUrl}/user/institute/getinstitute/${id}`
      );
      setInstituteDet(responseq.data);
      console.log("first", responseq.data);
    } catch (error) {
      console.error(error);
    }
  }

  return (
    InstituteDet !== null && (
      <>
        <div className="home-background">
          <Navbar logoimg={logo} />
        </div>
        <MobNav />
        <div className="comapre-bread">
          <h4 className="text-md-white text-black ">
            {InstituteDet ? InstituteDet.institute_profile[0].name + " ": ""}
            {Compare0.institute_profile ? "vs" + Compare0.institute_profile[0].name : ""}
          </h4>
          {/* <div className="search">
                    <input type="text" placeholder="Obepedia" />
                    <span><BiSearch />
                    </span>
                </div> */}
          <button onClick={handleShow} className="src-btn px-3">
            Choose Institute and Course
          </button>
        </div>
        <div className="compare-pages pt-0 d-none d-md-block">
          <div className="compare-shadow">
            <div className="content d-flex justify-content-center align-items-start flex-column">
              <h6>Compare Institutes</h6>
              <p>
                Select another institute and compare them for a good decision.
              </p>
            </div>
              <div
                className="content d-flex justify-content-center align-items-center flex-column"
              >
                <h6>{InstituteDet.institute_profile ? InstituteDet.institute_profile[0].name : ""}</h6>
                <p>{InstituteDet.institute_profile ? InstituteDet.institute_profile[0].location : ""}</p>
              </div>
                <div
                  className="content  d-flex justify-content-center align-items-center flex-column"
                >
                  <h6>{Compare0.institute_profile ? Compare0.institute_profile[0].name : ""}</h6>

                  <p>{Compare0.institute_profile ? Compare0.institute_profile[0].location : ""}</p>
                </div>
              
          </div>

          <div className=" institute mt-0 " style={{ paddingTop: "150px " }}>
            <h4 className="pb-5 fw-bold">Institute Info</h4>
            <div className="mb-5">
              <ul className="p-0">
                <li className="text-black" style={{ fontWeight: "500" }}>
                  {" "}
                  Established Year
                </li>
                <li className="text-center">{ InstituteDet.institute_profile ? InstituteDet.institute_profile[0].since : "0"}</li>
                <li className="text-center">{Compare0.institute_profile ? Compare0.institute_profile[0].since : "0"}</li>
              </ul>
              <ul className="p-0">
                <li className="text-black" style={{ fontWeight: "500" }}>
                  {" "}
                  Rating
                </li>
                <li className="text-center">{ InstituteDet.institute_rating === [] ? InstituteDet.institute_rating[0].rating : "0"}</li>
                <li className="text-center">{Compare0.institute_rating === [] ? Compare0.institute_rating[0].rating : "0"}</li>
              </ul>
              <ul className="p-0">
                <li className="text-black" style={{ fontWeight: "500" }}>
                  {" "}
                  Total Course
                </li>
                <li className="text-center">{ InstituteDet.course ? InstituteDet.course.length : "0"}</li>
                <li className="text-center">{Compare0.course ? Compare0.course.length : "0"}</li>
              </ul>
            </div>
            <h4 className="pb-5">Institute Details</h4>
            <div className="course-detail">
              <div className="content">
                <h6>About Institute</h6>
              </div>
                <div className="content">
                  <p>{InstituteDet.institute_profile ? parse(InstituteDet.institute_profile[0].about.slice(0, 500)): " "}...</p>
                </div>
                <div className="content">
                  <p className="abt">{Compare0.institute_profile ? parse(Compare0.institute_profile[0].about.slice(0, 600)) : ""}...</p>
                </div>
            </div>
          </div>

          <div className="institute mt-5">
            <h4 className="pb-4">Infrastructure & facilities</h4>
            <div className="mb-5">
              <ul className="p-0">
                <li className="text-black" style={{ fontWeight: "500" }}>
                  {" "}
                  Overall selection
                </li>
                <li className="text-center">{ InstituteDet.institute_profile ? InstituteDet.institute_profile[0].overall_selection : "0"}</li>
                <li className="text-center">{Compare0.institute_profile ? Compare0.institute_profile[0].overall_selection : "0"}</li>
              </ul>
              <ul className="p-0">
                <li className="text-black" style={{ fontWeight: "500" }}>
                  {" "}
                  Last year selection
                </li>
                <li className="text-center">{ InstituteDet.institute_profile ? InstituteDet.institute_profile[0].last_year_selection : "0"}</li>
                <li className="text-center">{Compare0.institute_profile ? Compare0.institute_profile[0].last_year_selection : "0"}</li>
              </ul>
              <ul className="p-0">
                <li className="text-black" style={{ fontWeight: "500" }}>
                  {" "}
                  Batch strength
                </li>
                <li className="text-center">{ InstituteDet.institute_profile ? InstituteDet.institute_profile[0].batch_strength : "0"}</li>
                <li className="text-center">{Compare0.institute_profile ? Compare0.institute_profile[0].batch_strength : "0"}</li>
              </ul>
              <ul className="p-0">
                <li className="text-black" style={{ fontWeight: "500" }}>
                  {" "}
                  Location
                </li>
                <li className="text-center">{ InstituteDet.institute_profile ? InstituteDet.institute_profile[0].city : ""}</li>
                <li className="text-center">{Compare0.institute_profile ? Compare0.institute_profile[0].city : ""}</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="compare-pages mobile d-block d-md-none">
          <div className="compare-shadow">
              <div
                className="content d-flex align-items-center flex-column justify-content-center"
              >
                <img src={InstituteDet.institute_profile ? InstituteDet.institute_profile[0].image : ""} alt="" className="mb-3" />
                <h6 className="text-center">{InstituteDet.institute_profile ? InstituteDet.institute_profile[0].name : ""}</h6>
                <p className="text-center">{InstituteDet.institute_profile ? InstituteDet.institute_profile[0].location : ""}</p>
              </div>

              {Compare0.institute_profile ? <div className="content d-flex align-items-center flex-column justify-content-center">
                <img src={Compare0.institute_profile[0].image} alt="" className="mb-3" />
                <h6 className="text-center">{Compare0.institute_profile[0].name}</h6>
                <p className="text-center">{Compare0.institute_profile[0].location}</p>
              </div> : ""}
          </div>

          <div className=" institute  mt-5">
            <h4 className="pb-5 fw-bold">Institute Info</h4>
            <h6 className="fw-semibold">Established Year</h6>
            <div>
              <div className="content d-flex">
                <p className="content-box">{ InstituteDet.institute_profile ? InstituteDet.institute_profile[0].since : "0"}</p>
                {Compare0 ?<p className="abt content-box">{Compare0.institute_profile ? Compare0.institute_profile[0].since : "0"}</p>: ""}
              </div>
            </div>
            <h6 className="fw-semibold"> Rating</h6>
            <div>
              <div className="content d-flex">
                <p className="content-box">{ InstituteDet.institute_rating === [] ? InstituteDet.institute_rating[0].rating : "0"}</p>
                {Compare0 ?<p className="abt content-box">{Compare0.institute_rating === [] ? Compare0.institute_rating[0].rating : "0"}</p>: ""}
              </div>
            </div>
            <h6 className="fw-semibold">Total Course</h6>
            <div>
              <div className="content d-flex">
                <p className="content-box">{ InstituteDet.course ? InstituteDet.course.length : "0"}</p>
                {Compare0 ?<p className="abt content-box">{Compare0.course ? Compare0.course.length : "0"}</p>: ""}
              </div>
            </div>
          </div>
          <div className=" institute mt-5">
            <h4 className="pb-4 fw-bold">About Institute</h4>
            <div>
              <div className="content d-flex flex-wrap ">
                <h6 className="text-center mb-3 fw-semibold">{InstituteDet.institute_profile ? InstituteDet.institute_profile[0].name : ""}</h6>
                  <p className="content-box about-content-box">
                    <span>{InstituteDet.institute_profile ? parse(InstituteDet.institute_profile[0].about.slice(0, 500)): " "} <Link className="text-success decoration_none" to={`/institute/${InstituteDet.institute_profile?InstituteDet.institute_profile[0].institute_id:""}`}>know more</Link></span>
                  </p>

                {Compare0 ?<><h6 className="text-center my-3 fw-semibold">{Compare0.institute_profile ? Compare0.institute_profile[0].name : ""}</h6>
                  <p className="abt content-box about-content-box">
                    <span>{Compare0.institute_profile ? parse(Compare0.institute_profile[0].about.slice(0, 600)) : ""}<Link className="text-success decoration_none" to={`/institute/${Compare0.institute_profile?Compare0.institute_profile[0].institute_id:""}`}>know more</Link></span>
                  </p></> : ""}
              </div>
            </div>
          </div>

          <div className="institute mt-5">
            <h4 className="pb-5 fw-bold">Infrastructure & facilities</h4>
            <h6 className="fw-semibold">Overall selection</h6>
            <div>
              <div className="content d-flex">
                <p className="content-box">{ InstituteDet.institute_profile ? InstituteDet.institute_profile[0].overall_selection : "0"}</p>
                {Compare0 ?<p className="abt content-box">{Compare0.institute_profile ? Compare0.institute_profile[0].overall_selection : "0"}</p>: ""}
              </div>
            </div>
            <h6 className="fw-semibold">Last year selection</h6>
            <div>
              <div className="content d-flex">
                <p className="content-box">{ InstituteDet.institute_profile ? InstituteDet.institute_profile[0].last_year_selection : "0"}</p>
                {Compare0 ?<p className="abt content-box">{ InstituteDet.institute_profile ? InstituteDet.institute_profile[0].last_year_selection : "0"}</p>: ""}
              </div>
            </div>
            <h6 className="fw-semibold">Batch strength</h6>
            <div>
              <div className="content d-flex">
                <p className="content-box about-content-box">
                { InstituteDet.institute_profile ? InstituteDet.institute_profile[0].batch_strength : "0"}
                </p>
                {Compare0 ?<p className="abt content-box about-content-box">
                {Compare0.institute_profile ? Compare0.institute_profile[0].batch_strength : "0"}
                </p>: ""}
              </div>
            </div>
            <h6 className="fw-semibold">Location</h6>
            <div>
              <div className="content d-flex">
                <p className="content-box about-content-box">
                { InstituteDet.institute_profile ? InstituteDet.institute_profile[0].city : ""}
                </p>
                {Compare0 ?<p className="abt content-box about-content-box">
                {Compare0.institute_profile ? Compare0.institute_profile[0].city : ""}
                </p>: ""}
              </div>
            </div>
          </div>
        </div>

        <Footer />
        <FooterMob />

        <Modal show={show} onHide={handleClose} className="compare-popup">
          <Modal.Body>
            <div className="mb-3">
              <label htmlFor="institutes" className="form-label">
                <h5>Institute Selection</h5>
              </label>
              <select
                onChange={(e) => GetCourse(e.target.value)}
                className="form-select form-select-lg"
                name=""
                id="institutes"
              >
                <option selected>Select one</option>
                {data.map((item, index) => (
                  <option key={index} value={item._id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>

            <Button variant="primary" onClick={() => Compare()}>
              Compare
            </Button>
          </Modal.Body>
        </Modal>
      </>
    )
  );
};

export default ComparePage;
